import { EmptyValue } from "@bcc/components/ui";
import { formatCurrency } from "@client-shared/utils";
import type { PurchaseOrderInvoice } from "@shared/types/payout";
import { CellContext } from "@tanstack/react-table";

export const InvoiceAmountCell = (props: CellContext<PurchaseOrderInvoice, unknown>) => {
  const amount = props.getValue() as number;
  const currency = props.row.original.currencyCode || "USD";
  const invoiceStatus = props.row.original.invoiceStatus;

  if (invoiceStatus === "Unposted") {
    return (
      <div className="text-sm leading-snug">
        <EmptyValue />
      </div>
    );
  }

  return <div>{formatCurrency(amount, currency)}</div>;
};
